import { render, staticRenderFns } from "./armorEnchantments.vue?vue&type=template&id=0216c0e5&scoped=true&"
import script from "./armorEnchantments.vue?vue&type=script&lang=js&"
export * from "./armorEnchantments.vue?vue&type=script&lang=js&"
import style0 from "./armorEnchantments.vue?vue&type=style&index=0&id=0216c0e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216c0e5",
  null
  
)

export default component.exports